export const defaultValidation = {
  email: { error: false },
  name: { error: false },
  careerName: { error: false },
  thank: { error: false }
};
